// routes.js — the Attendly route table (single source of truth the router uses).
// Each entry:
//   path  — pattern with :params (compiled to regex; params arrive as attributes
//           on the mounted element, declared in each page's static props)
//   name  — stable id (state.route.value.name) for active-nav / analytics
//   tag   — custom element the route mounts (registered as a side effect of load())
//   auth  — DEMO MODE: every request runs as a per-browser guest (plan 'pro'), so
//           nothing is auth-gated yet. Left as a column for when real login lands.
//   load  — lazy import() so each page is its own code-split chunk.
//
// Order matters — first match wins; literal paths before parametric siblings.

export const ROUTES = [
  { path: '/',             name: 'landing',    tag: 'pg-page-landing',     auth: false, load: () => import('./pages/landing.js') },
  { path: '/get-started',  name: 'onboarding', tag: 'pg-page-onboarding',  auth: false, load: () => import('./pages/onboarding.js') },
  { path: '/dashboard',    name: 'dashboard',  tag: 'pg-page-dashboard',   auth: false, load: () => import('./pages/dashboard.js') },
  { path: '/agent/:id',    name: 'console',    tag: 'pg-page-console',     auth: false, load: () => import('./pages/console.js') },
  // Public embedded chat surface — the iframe target the embed loader opens.
  { path: '/c/:token',     name: 'embed-chat', tag: 'pg-page-embed-chat',  auth: false, load: () => import('./pages/embed-chat.js') },
];
